export enum ProjectStatus {
  IN_PROGRESS = "in_progress",
  DONE = "done",
}
